/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import $ from 'jquery';
import PsContext from './PsContext';
import {
  setlsItem, getlsItem, getls,
} from '../../utils';

// Then create a provider Component
class PsContextProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logged: getlsItem('userLogged') || 'NO',
      api: getlsItem('loggedApi') || '',
      company: getlsItem('loggedCompany') ? JSON.parse(getlsItem('loggedCompany')) : [],
      user: getlsItem('loggedUser') ? JSON.parse(getlsItem('loggedUser')) : [],
	  header: getlsItem('appHeader') ? JSON.parse(getlsItem('appHeader')) : [],
    };

		this.updateLogin = this.updateLogin.bind(this);
		this.updateHeader = this.updateHeader.bind(this);
		this.updateCompany = this.updateCompany.bind(this);
		this.logout = this.logout.bind(this);
		
  }

  componentDidMount() {
    
  }
  
  updateCompany(companyData){
	  setlsItem('loggedCompany', JSON.stringify(companyData));
	  this.setState({
			company: companyData,
		});
  }

	updateLogin(userApi, userData, companyData){
		setlsItem('userLogged', 'YES');
		setlsItem('loggedApi', userApi);
		setlsItem('loggedCompany', JSON.stringify(companyData));
		setlsItem('loggedUser', JSON.stringify(userData));
		this.setState({
			logged: 'YES',
			api: userApi,
			company: companyData,
			user: userData,
		});
	}

	updateHeader(header){
		setlsItem('appHeader', JSON.stringify(header));
		this.setState({
			header: header,
		});
	}
	
	logout(){
		setlsItem('userLogged', 'NO');
		setlsItem('loggedApi', '');
		setlsItem('loggedCompany', '');
		setlsItem('loggedUser', '');
		this.setState({
			logged: 'NO',
			company: [],
			user: [],
		});
	}

  render() {
    return (
      <PsContext.Provider value={{
        state: this.state, 
		updateLogin: this.updateLogin,
		updateHeader: this.updateHeader,
		updateCompany: this.updateCompany,
		logout: this.logout,
      }}
      >
        {this.props.children}
      </PsContext.Provider>
    );
  }
}

export default PsContextProvider;
